import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const RequireTwoFactorVerification = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user.two_factor_enabled && !user.two_factor_verified) {
    return <Navigate to="/verify-2fa" replace state={{ from: location }} />;
  }

  return children;
};

export default RequireTwoFactorVerification;
